export default class Recipient {
  public id: string;
  public firstName: string;
  public lastName: string;
  public created: string;
  public status: string;

  constructor(options) {
    this.id = options.id;
    this.firstName = options.firstName;
    this.lastName = options.lastName;
    this.created = options.created;
    this.status = options.status;
  }
}
